<template>
    <div class="basic_wrap ranking">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('Rankings')}}</div>
        </div>
        <div class="custom">
            <van-tabs v-model="active">
                <van-tab title="Team Ranking">
                    <div class="wrap">
                        <div class="top1">
                            <div>{{ numberTop1 && numberTop1.username }}</div>
                            <div class="desc">{{ numberTop1 && numberTop1.total_num || 0 }}</div>
                        </div>
                        <div class="top2">
                            <div>{{ numberTop2 && numberTop2.username }}</div>
                            <div class="desc">{{ numberTop2 && numberTop2.total_num || 0 }}</div>
                        </div>
                        <div class="top3">
                            <div>{{ numberTop3 && numberTop3.username }}</div>
                            <div class="desc">{{ numberTop3 && numberTop3.total_num || 0 }}</div>
                        </div>
                        <div class="other">
                            <div class="other-bg" v-if="numberOthers.length > 0">
                                <div class="item" v-for="(item, index) in numberOthers">
                                    <div class="circle">{{ index + 4 }}</div>
                                    <div class="info">
                                        <div class="name">{{ item.username }}</div>
                                        <div class="amount">{{ item && item.total_num || 0 }}</div>
                                    </div>
                                </div>

                            </div>
                            <div style="height: 50px;"></div>
                        </div>
                    </div>
                </van-tab>
                <van-tab title="Recharge Ranking">
                    <div class="wrap">
                        <div class="top1">
                            <div>{{ rechargeTop1 && rechargeTop1.username }}</div>
                            <div class="desc">{{ Number(rechargeTop1 && rechargeTop1.total_recharge || 0).toFixed(2) }}</div>
                        </div>
                        <div class="top2">
                            <div>{{ rechargeTop2 && rechargeTop2.username }}</div>
                            <div class="desc">{{ Number(rechargeTop2 && rechargeTop2.total_recharge || 0).toFixed(2) }}</div>
                        </div>
                        <div class="top3">
                            <div>{{ rechargeTop3 && rechargeTop3.username }}</div>
                            <div class="desc">{{ Number(rechargeTop3 && rechargeTop3.total_recharge || 0).toFixed(2) }}</div>
                        </div>
                        <div class="other">
                            <div class="other-bg" v-if="rechargeOthers.length > 0">
                                <div class="item" v-for="(item, index) in rechargeOthers">
                                    <div class="circle">{{ index + 4 }}</div>
                                    <div class="info">
                                        <div class="name">{{ item.username }}</div>
                                        <div class="amount">{{ Number(item && item.total_recharge || 0).toFixed(2) }}</div>
                                    </div>
                                </div>

                            </div>
                            <div style="height: 50px;"></div>
                        </div>
                    </div>
                </van-tab>
                <van-tab title="Team Members">
                    <div class="other-wrap">
                        <div class="total">
                            <div>Team Members Total</div>
                            <div>{{ mine.total_num || 0 }}</div>
                        </div>
                        <div class="vip" v-for="(item, index) in sub_levels">
                            <span>{{item.name}}</span>
                            <span>{{item.total}}</span>
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
        </div>



        <div @click="showRule = true" class="rule">
            <img src="@/assets/images/rule.svg">
        </div>
        <!-- 活动规则 -->
        <van-popup v-model="showRule" position="center" round :style="{ width: '80%', padding: '16px' }">
            <div class="action-sheet-center">
                <div class="text-center font-16 font-bold mt-10 font-white">{{rule.title}}</div>
                <div class="mt-20 font-14 font-white" v-html="rule.content"></div>
                <div class="btn-white" @click="showRule = false">{{$t('OK')}}</div>
            </div>
        </van-popup>

    </div>
</template>

<script>
    import Fetch from "../../utils/fetch";

    export default {
        name: "ranking",
        data() {
            return {
                list:[],
                activeNames: [],
                others: [],
                rule: {},
                showRule: false,
                active:0,
                rechargeTop1: {},
                rechargeTop2: {},
                rechargeTop3: {},
                rechargeOthers: [],
                numberTop1: {},
                numberTop2: {},
                numberTop3: {},
                numberOthers: [],
                mine: {},
                sub_levels: []
            }
        },
        created() {
            this.$parent.footer('index', false);
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                // 获取排行榜数据
                Fetch('/index/rankings', { }).then(res => {
                    this.rule = res.data.rule;

                    this.rechargeTop1 = res.data.recharge.top1;
                    this.rechargeTop2 = res.data.recharge.top2;
                    this.rechargeTop3 = res.data.recharge.top3;
                    this.rechargeOthers = res.data.recharge.others;

                    this.numberTop1 = res.data.number.top1;
                    this.numberTop2 = res.data.number.top2;
                    this.numberTop3 = res.data.number.top3;
                    this.numberOthers = res.data.number.others;

                    this.mine = res.data.mine;
                    this.sub_levels = res.data.mine.sub_levels;


                    // // 测试使用
                    // this.top1 =  {username:'123',total_recharge:1000}
                    // this.top2 =  {username:'123',total_recharge:1000}
                    // this.top3 =  {username:'123',total_recharge:1000}
                    // this.others = [
                    //     {username:'123',total_recharge:1000},
                    //     {username:'123',total_recharge:1000},
                    //     {username:'123',total_recharge:1000},
                    //     {username:'123',total_recharge:1000},
                    //     {username:'123',total_recharge:1000},
                    //     {username:'123',total_recharge:1000},
                    // ];
                })
            },
        },
    }
</script>

<style lang="less" scoped>
    .basic_wrap {
        width: 100%;
        min-height: 100vh;
        /*background: url("~@/assets/images/rankings.png") no-repeat top left;*/
        /*background-size: 100% auto; !* 宽度100%，高度按比例自适应 *!*/
    }
    .back_left {
        background: url(../../views/images/item/back.png) no-repeat center center;
    }
    .big_tit{
        color: #fff;
    }
    .red_top_bg {
        background: #1f65e6;
    }
    .wrap {
        background:
                url("~@/assets/images/rankings.png") no-repeat top left,
                #1f65e6;
        background-size: 100% auto;
        min-height: calc(100vh - 88px);
    }
    .top1 {
        top: 176px;
        left: 142px;
        width: 90px;
    }
    .top2 {
        top: 216px;
        left: 40px;
        width: 90px;
    }
    .top3 {
        top: 219px;
        right: 39px;
        width: 95px;
    }
    .top1, .top2 , .top3 {
        position: absolute;
        text-align: center;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #fff;
        .desc {
            background: #76a1f0;
            padding: 5px 10px;
            color: #fff;
            font-size: 13px;
            display: inline-block;
            border-radius: 5px;
        }
    }
    .top1 .desc {
        background: linear-gradient(145deg, #FFD700 0%, #FFC107 100%);
        min-width: 50px;
    }
    .top2 .desc {
        background: linear-gradient(145deg, #E0E0E0 0%, #C0C0C0 100%);
        min-width: 50px;
    }
    .top3 .desc {
        background: linear-gradient(145deg, #D18B49 0%, #B87333 100%);
        min-width: 50px;
    }
    .other {
        /*background: #2066e6;*/
        width: 100%;
        padding-top: 360px;
        min-height: 300px;
    }
    .other-bg {
        background: #f0efff;
        margin: 20px 15px 0px 15px;
        padding: 20px;
        border-radius: 10px;
    }
    .item {
        display: flex;          /* 左右布局 */
        align-items: center;    /* 垂直居中 */
        gap: 20px;              /* 左右间距 */
        background: #fff;
        padding: 15px;
        border-radius: 10px;
        margin-bottom: 15px;
    }
    .item:last-child {
        margin-bottom: 0;   /* 最后一个不要间距 */
    }
    .info {
        display: flex;
        flex-direction: column; /* 上下布局 */
        justify-content: center;
    }

    .name {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 10px;
    }

    .amount {
        font-size: 14px;
        color: #666;
    }
    /* 小平板：iPad Mini, 768px 宽度 */
    @media screen and (max-width: 768px) {
        .top1 {
            top: 365px;
            left: 308px;
            width: 135px;
        }
        .top2 {
            top: 436px;
            left: 102px;
            width: 135px;
        }
        .top3 {
            top: 439px;
            right: 105px;
            width: 135px;
        }
    }
    /* 大屏手机：iPhone 14 Plus, 430px 宽度 */
    @media screen and (max-width: 430px) {
        .top1 {
            top: 247px;
            left: 155px;
            width: 120px;
        }
        .top2 {
            top: 288px;
            left: 48px;
            width: 100px;
        }
        .top3 {
            top: 291px;
            right: 49px;
            width: 100px;
        }
    }
    /* 大屏手机：iPhone 6/7/8 Plus, 414px 宽度 */
    @media screen and (max-width: 414px) {
        .top1 {
            top: 239px;
            left: 147px;
            width: 120px
        }
        .top2 {
            top: 278px;
            left: 44px;
            width: 100px;
        }
        .top3 {
            top: 280px;
            right: 45px;
            width: 100px;
        }
    }
    /* 中屏手机：iPhone 12, 390px 宽度 */
    @media screen and (max-width: 390px) {
        .top1 {
            top: 226px;
            left: 135px;
            width: 120px;
        }
        .top2 {
            top: 264px;
            left: 40px;
            width: 100px;
        }
        .top3 {
            top: 267px;
            right: 39px;
            width: 100px;
        }
    }
    /* 中屏手机：iPhone 6/7/8, 375px 宽度 */
    @media screen and (max-width: 375px) {
        .top1 {
            top: 219px;
            left: 142px;
            width: 90px;
        }
        .top2 {
            top: 255px;
            left: 40px;
            width: 90px;
        }
        .top3 {
            top: 259px;
            right: 39px;
            width: 95px;
        }
    }
    /* 小屏手机：iPhone SE, 360px 宽度 */
    @media screen and (max-width: 360px) {
        .top1 {
            top: 212px;
            left: 135px;
            width: 90px;
        }
        .top2 {
            top: 245px;
            left: 36px;
            width: 90px;
        }
        .top3 {
            top: 247px;
            right: 32px;
            width: 95px;
        }
    }
    /* 344px 宽度 */
    @media screen and (max-width: 344px) {
        .top1 {
            top: 205px;
            left: 127px;
            width: 90px;
        }
        .top2 {
            top: 239px;
            left: 34px;
            width: 90px;
        }
        .top3 {
            top: 243px;
            right: 32px;
            width: 95px;
        }
    }

    .other-wrap {
        background: #1f65e6;
        min-height: calc(100vh - 88px);
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 15px; /* 增加一些间距 */
    }

    /* 顶部总人数：上下布局 */
    .other-wrap .total {
        display: flex;
        flex-direction: column; /* 上下排列 */
        justify-content: center; /* 垂直居中 */
        align-items: center;     /* 水平居中 */
        padding: 20px 15px;
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.2);
        color: #fff;
        font-weight: bold;
        font-size: 20px;
        box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    }

    /* 总人数文字大小区分 */
    .other-wrap .total div:first-child {
        font-size: 16px; /* "总人数"字样稍小 */
        margin-bottom: 20px; /* 与数字间距 */
    }

    .other-wrap .total div:last-child {
        font-size: 20px; /* 人数数字更醒目 */
    }

    /* VIP 列表，每一行 */
    .other-wrap .vip {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 15px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.1);
        color: #fff;
        font-weight: bold;
        font-size: 14px;
        transition: all 0.3s ease;
        cursor: pointer;
    }

    /* VIP 悬停效果 */
    .other-wrap .vip:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: translateX(5px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }

    .other-wrap .vip span:last-child {
        transition: color 0.3s ease;
    }

    .other-wrap .vip:hover span:last-child {
        color: #FFD700;
    }

</style>